module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/readable-stream/transform.js
// module id = 346
// module chunks = 0